
import {computed, defineComponent, ref} from 'vue'
import ParameterControls from "@/components/ParameterControls.vue";
import {HandySimulator} from '@/HandySimulator'
import {initialParams, SimulationParameters} from '@/store/SimulationParameters';
import LineChart from "@/components/LineChart.vue";

export default defineComponent({
  components: {
    LineChart,
    ParameterControls,
  },
  setup() {
    // Copy initial parameters.
    const simulationParameters = ref({...initialParams});
    const updateParameters = function(currentParameters: SimulationParameters) {
      simulationParameters.value = currentParameters;
    };

    const chartData = computed(() => {
      // TODO: Debounce, kill running simulation
      return new HandySimulator()
        .runSimulation(simulationParameters.value);
    });

    return {
      chartData,
      initialParams,
      updateParameters,
    }
  }
});
